import { Injectable, inject } from '@angular/core';
import { WINDOW } from './window.service';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private readonly window = inject<Window>(WINDOW);

  #session: WindowSessionStorage;

  constructor() {
    this.#session = this.window;
  }

  set(key: string, value: string): void {
    this.#session.sessionStorage.setItem(key, value);
  }

  get(key: string): string {
    return this.#session.sessionStorage.getItem(key) ?? '';
  }

  getModel<T>(key: string): T {
    return JSON.parse(this.get(key)) as T;
  }

  has(key: string): boolean {
    return this.#session.sessionStorage.getItem(key) !== null;
  }

  remove(key: string): void {
    this.#session.sessionStorage.removeItem(key);
  }
}
